<template>
  <div class="root">
    <img class="logo" src="@/assets/logo.svg" />
    <div class="slide" @click="onClick1" v-show="currentPage === 1">
      <img src="@/assets/suisui1.svg" />
      <p class="title">観光施設や飲食店がひとめでわかる</p>
      <p class="sub">
        施設にチェックインして旅の記録をつけよう。<br />
        ミッションをクリアすればポイントも貯まります。
      </p>
    </div>
    <div class="slide" @click="onClick2" v-show="currentPage === 2">
      <img src="@/assets/suisui2.svg" />
      <p class="title">渋滞予測で車の旅もスイスイ</p>
      <p class="sub">
        マップアプリと連携して渋滞情報もリアルタイム更新。<br />
        無駄な待ち時間をなくして快適な旅を。
      </p>
    </div>
    <div class="slide" @click="onClick3" v-show="currentPage === 3">
      <img src="@/assets/suisui3.svg" />
      <p class="title">ミッションクリアのご褒美</p>
      <p class="sub">
        ミッションをクリアして貯まったポイントを景品と交換。<br />
        豪華な景品を当てる！
      </p>
    </div>
    <div class="progress">
      <div @click="onClickSkip">SKIP</div>
      <div class="circles">
        <div
          v-for="i in 3"
          :key="i"
          class="cricle"
          :class="{ active: i === currentPage }"
        >
          ●
        </div>
      </div>
      <div class="next" @click="onClickNext">NEXT</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "tuotrial",
  components: {},
  computed: {},
  data() {
    return {
      currentPage: 1,
    };
  },
  methods: {
    onClick1() {
      this.currentPage = 2;
    },
    onClick2() {
      this.currentPage = 3;
    },
    onClick3() {
      this.$router.push({ name: "Consent" });
    },
    onClickNext() {
      if (this.currentPage === 3) {
        this.$router.push({ name: "Consent" });
      } else {
        this.currentPage = this.currentPage + 1;
      }
    },
    onClickSkip() {
      this.$router.push({ name: "Consent" });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";

.root {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 100%;

  .logo {
    margin-top: 10%;
    width: 50vw;
  }
  .slide {
    display: flex;
    flex-direction: column;
    justify-content: center;
    img {
      height: 25vh;
      margin: 0 auto;
    }
    .title {
      text-align: center;
      margin: 6% 0 2%;
    }
    .sub {
      color: #a3a3a3;
      font-size: 0.6rem;
      text-align: center;
      margin: 0;
    }
  }

  .progress {
    display: flex;
    justify-content: space-between;
    width: calc(100% - 10vw);
    gap: 3vw;
    margin-bottom: 5%;
    .circles {
      display: flex;
      gap: 4vw;

      .cricle {
        color: #5cd5d6;
        opacity: 0.3;
        &.active {
          opacity: 1;
        }
      }
    }
  }

  .skip {
    color: #1f1f1f;
  }

  .next {
    color: #5cd5d6;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Tutorial.vue